import { FormEventHandler } from 'react';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { AbsatzVorgabe } from '@/domain/controlling/entities';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const numberMaskingOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: '.',
  min: 0,
  decimalSeparator: ',',
});

export function AbsatzProduktivitaetWithAbsatzVorgabeOptions({
  onInput,
  onOptionsChange,
  defaultOption,
  onBlur,
  defaultInputValue,
  isValid = true,
}: {
  onInput: FormEventHandler<HTMLInputElement>;
  onOptionsChange: (value: AbsatzVorgabe) => void;
  onBlur: () => void;
  defaultOption: AbsatzVorgabe;
  defaultInputValue: string;
  isValid?: boolean;
}) {
  const inputRef = useMaskito({ options: numberMaskingOptions });
  const { t } = useTranslation();

  return (
    <div
      className={`w-full px-4 flex items-center rounded-md bg-white outline outline-1 ${
        isValid ? 'outline-neutrals-300' : 'outline-primary-red-500'
      } -outline-offset-1 has-[input:focus-within]:outline-solid has-[input:focus-within]:outline-1 has-[input:focus-within]:-outline-offset-1 has-[input:focus-within]:outline-neutrals-900 transform transition-colors}`}>
      <input
        ref={inputRef}
        className="peer block min-w-0 text-sm leading-6 py-[10px] grow focus:outline-solid focus:outline-0"
        onInput={onInput}
        defaultValue={defaultInputValue}
        onBlur={() => onBlur()}
      />
      <Select
        defaultValue={defaultOption}
        onValueChange={(value: AbsatzVorgabe) => onOptionsChange(value)}>
        <SelectTrigger
          autoFocus={false}
          className="bg-transparent p-0 border-0 w-fit text-md data-[state=open]:text-primary-blue-600 focus:ring-0 peer-focus:text-primary-blue-600 text-neutrals-700 placeholder:text-neutrals-500">
          <SelectValue className="pr-2" placeholder={defaultOption} />
        </SelectTrigger>
        <SelectContent align="end" className="shadow-md border-0">
          <SelectItem className="text-md" value={AbsatzVorgabe.Stueck}>
            {t('domain.controlling.umsatzplanung.units.Stk./Std.')}
          </SelectItem>
          <SelectItem className="text-md" value={AbsatzVorgabe.Mpt}>
            {t('domain.controlling.umsatzplanung.units.mpt')}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
